import React from "react";
import { AppReferenceManyField } from "components/list/AppReferenceManyField";

import { HistoryDatagrid } from './Grid';


export const HistoryField = ({children, ...props}) => (
	<AppReferenceManyField {...props}>
		<HistoryDatagrid children={children} />
	</AppReferenceManyField>
);


HistoryField.defaultProps = {
	addLabel: true,
	className: "ra-field-datagrid",
};
